import { useState } from 'react'

import * as authService from 'services/auth'
import { useCountdown } from 'hooks/use-countdown'
import { PhoneAccountLookupResult, interpretPhoneAccounts, interpretPhoneAccountsError } from 'utils/phone-accounts'

/** `POST /auth/phone/v2/accounts` with the 429 `Retry-After` cooldown kept as state. */
export function usePhoneAccountLookup() {
	const [retryAt, setRetryAt] = useState<string | null>(null)
	const retry = useCountdown(retryAt)

	const lookup = async (phoneNumber: string, turnstileToken?: string): Promise<PhoneAccountLookupResult> => {
		try {
			// The api instance resolves with the response body
			const accounts: unknown = await authService.phoneAccounts({ phoneNumber }, turnstileToken)
			setRetryAt(null)
			return interpretPhoneAccounts(accounts)
		} catch (error) {
			const result = interpretPhoneAccountsError(error)
			if (result.kind === 'rateLimited') setRetryAt(result.retryAt.toISOString())
			return result
		}
	}

	return { lookup, retrySecondsLeft: retry.secondsLeft, retryFormatted: retry.formatted }
}
